import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { getQuestionUrl, getLearningObjectiveUrl } from 'utils/navigation';
import withNavigation from 'components/hocs/withNavigation';
import { getBackground, isPreviewMode } from 'store/settings/selectors';
import { getQuestionSection } from 'store/questions/selectors';
import {
  getCourseTitle,
  getCourseIntroductions,
  isCourseAccessLimited,
  getPreviewQuestionId
} from 'store/course/selectors';
import { getSections, affectsProgress } from 'store/sections/selectors';
import SectionsListComponent from 'components/sections/SectionsList';
import CourseInformation from 'components/sections/CourseInformation';
import { localize } from 'core/localization';
import { clearPreviewQuestionId } from 'store/course/actions';
import {
  SectionListContainer,
  SectionsPageSidebar,
  SectionsPageContent
} from './SectionsPage.styled';

export class Sections extends Component {
  navigateToQuestion = (sectionId, questionId) => {
    this.props.navigateToUrl(getQuestionUrl(sectionId, questionId));
  };

  navigateToLearningObjective = sectionId => {
    this.props.navigateToUrl(getLearningObjectiveUrl(sectionId));
  };

  componentDidMount() {
    if (this.props.previewQuestionId) {
      this.props.clearPreviewQuestionIdAction();
      this.navigateToQuestion(this.props.previewSectionId, this.props.previewQuestionId);
    }

    document.title = `${localize('[section page title]')} | ${this.props.title}`;
  }

  render() {
    let { sections, background, isAccessLimited } = this.props;
    return isAccessLimited ? (
      ''
    ) : (
      <Fragment>
        <SectionsPageSidebar background={background}>
          <CourseInformation sections={sections} />
        </SectionsPageSidebar>
        <SectionsPageContent background={background}>
          <SectionListContainer>
            <SectionsListComponent
              sections={sections}
              navigateToQuestion={this.navigateToQuestion}
              navigateToLearningObjective={this.navigateToLearningObjective}
            />
          </SectionListContainer>
        </SectionsPageContent>
      </Fragment>
    );
  }

  static propTypes = {
    sections: PropTypes.array.isRequired,
    navigateToUrl: PropTypes.func.isRequired,
    isAccessLimited: PropTypes.bool.isRequired,
    previewQuestionId: PropTypes.string,
    previewSectionId: PropTypes.string,
    clearPreviewQuestionIdAction: PropTypes.func,
    theme: PropTypes.object,
    background: PropTypes.object,
    title: PropTypes.string
  };
}

function mapDispatchToProps(dispatch) {
  return { clearPreviewQuestionIdAction: bindActionCreators(clearPreviewQuestionId, dispatch) };
}

function mapStateToProps(state) {
  let props = {
    title: getCourseTitle(state),
    introductions: getCourseIntroductions(state),
    sections: getSections(state).map(section => ({
      ...section,
      affectsProgress: affectsProgress(state, section.id)
    })),
    background: getBackground(state),
    isAccessLimited: isCourseAccessLimited(state)
  };

  let previewQuestionId = getPreviewQuestionId(state);
  if (isPreviewMode(state) && previewQuestionId) {
    props.previewQuestionId = previewQuestionId;
    props.previewSectionId = getQuestionSection(state, props.previewQuestionId);
  }

  return props;
}

export default withNavigation(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Sections)
);
